// extracted by mini-css-extract-plugin
export default {"overlay":"loadingOverlay_overlay__-mm2x","container":"loadingOverlay_container__pJbjc"};